import React from 'react';
import PropTypes from 'prop-types';
import { Card, Row, Col } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const MonitoringStatItemSkeleton = ({ className }) => {
  return (
    <Col lg={3} className={className}>
      <p className="fs--1 fw-semi-bold mb-0">
        <span className="text-800 fw-normal">
          <Skeleton />
        </span>
      </p>
      <h4 className="mb-1 font-sans-serif">
        <span className="fw-normal text-green-600">
          <Skeleton />
        </span>
      </h4>
    </Col>
  );
};

const MonitoringStatsSkeleton = () => {
  return (
    <Card>
      <Card.Body>
        <Row className="g-0">
          <MonitoringStatItemSkeleton className="pb-3 pe-lg-3 pb-lg-0" />
          <MonitoringStatItemSkeleton className="py-3 px-lg-3 py-lg-0" />
          <MonitoringStatItemSkeleton className="py-3 px-lg-3 py-lg-0" />
          <MonitoringStatItemSkeleton className="pt-3 pt-lg-0 ps-lg-3" />
        </Row>
      </Card.Body>
    </Card>
  );
};

MonitoringStatItemSkeleton.propTypes = {
  className: PropTypes.string
};

export default MonitoringStatsSkeleton;
